export default __webpack_public_path__ + "static/media/afaaq bhai.8196dde3.jpg";